import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { initRegisterForm, initForgotPasswordForm, signInUser, signInClick, verifyRecaptchaToken, verifyRecaptchaTokenv2 } from '../core-actions'
import CoreSignIn from '../components/core-sign-in'

const mapStateToProps = state => {
  return {
    theme: state.core.theme,
    signInClicked: state.core.user.signInClicked
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      signInUser,
      signInClick,
      initForgotPasswordForm,
      initRegisterForm,
      verifyRecaptchaToken,
      verifyRecaptchaTokenv2
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoreSignIn)
